import { Link } from '@inertiajs/react'
import { FileText } from 'lucide-react'
import { fdeProjectPath, fdeRoutes } from '@/frontend/features/Fde/routes'

export default function ProjectPlanLinks({
  paths,
  projectId,
}: {
  paths: string[]
  projectId: string
}) {
  if (!paths.length) return null
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-2">
      {paths.map((path) => (
        <Link
          key={path}
          href={fdeProjectPath(fdeRoutes.material, projectId, { file: path })}
          title={path}
          className="flex min-w-0 max-w-full items-center gap-1.5 text-xs text-muted-foreground hover:text-primary"
        >
          <FileText className="size-3.5 shrink-0" />
          <span className="truncate">{path.split('/').pop()}</span>
        </Link>
      ))}
    </div>
  )
}
